import { gql } from '@/apollo';

export const USER_ORGANIZATION_TEAMS_QUERY = gql(`
  query userOrganizationTeamsQuery {
    me {
      rowId
      organizations(first: 1) {
        nodes {
          rowId
          teams {
            totalCount
            nodes {
              rowId
              name
              accountId
              avatar
              members {
                totalCount
              }
              bots {
                totalCount
              }
            }
          }
        }
      }
    }
  }
`);
